import { authApi } from 'common/modules/ReactShared';
import { createAsyncThunk } from '@reduxjs/toolkit';

const acceptInvitation = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'invitations/acceptInvitation_request',
  async (data, { rejectWithValue }) => {
    try {
      return await authApi.acceptInvitation(data).catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText || 'Error happened while trying to accept invitation'
      );
    }
  }
);

export const invitationsActions = { acceptInvitation };
